import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpService} from '../../../core';
import {environment} from '../../../../environments/environment';
import {UserService} from '../../../core/services/user.service';
import {DomSanitizer} from "@angular/platform-browser";

@Component({
  selector: 'app-project-analytics',
  templateUrl: './project-analytics.component.html',
  styleUrls: ['./project-analytics.component.scss']
})
export class ProjectAnalyticsComponent implements OnInit {

  projectId: any;
  @Input() project: any;
  @Input() availableNum: number;
  @Input() soldNum: number;
  @Input() reserveNum: number;
  SERVER_URL = environment.SERVER_URL;
  currentUserId: any;
  orderPercentage = {
    title: 'Transaction Conversion Percentage',
    colors: ['#FF0D90', '#05CD99'],
    legendData: ['Yes (28%)', 'No (72%)'],
    seriesData: [{value: 28, name: 'Yes (28%)'}, {value: 72, name: 'No (72%)'}]

  };
  chanelPreference = {
    title: 'Chanel Preference',
    colors: ['#FF0D90', '#8676FF', '#A7E7F2', '#05CD99', '#FFAD47'],
    legendData: ['Web', 'Mobile', 'Pad', 'Wechat Mini Programs', 'Others'],
    seriesData: [{value: 28, name: 'Web'}, {value: 47, name: 'Mobile'}, {value: 7, name: 'Pad'}, {
      value: 12, name: 'Wechat Mini Programs'
    }, {value: 6, name: 'Others'}]
  };
  visitorsDistribution = {
    title: 'Visitors Distribution',
    colors: ['#FF0D90', '#05CD99', '#8676FF', '#A7E7F2', '#FFAD47', '#E95513'],
    legendData: ['Melbourne', 'Sydney', 'Brisbane', 'Bendigo', 'Gold Coast', 'Others'],
    seriesData: [{value: 38, name: 'Melbourne'}, {value: 25, name: 'Sydney'}, {value: 21, name: 'Brisbane'}, {
      value: 6, name: 'Bendigo'
    }, {value: 3, name: 'Gold Coast'}, {value: 7, name: 'Others'}]
  };
  visitorsSource = {
    title: 'Visitors Source',
    colors: ['#FF0D90', '#05CD99', '#8676FF', '#A7E7F2', '#FFAD47', '#E95513', '#454F85'],
    legendData: ['Yephome', 'Facebook', 'Twitter', 'Wechat', 'SMS', 'Email', 'Others'],
    seriesData: [{value: 45, name: 'Yephome'}, {value: 19, name: 'Wechat'}, {value: 16, name: 'Facebook'}, {
      value: 10, name: 'Twitter'
    }, {value: 5, name: 'Email'}, {value: 3, name: 'SMS'}, {value: 2, name: 'Others'}]
  };
  visitorsLanguage = {
    title: 'Visitors Language',
    colors: ['#FF0D90', '#05CD99', '#8676FF', '#A7E7F2', '#FFAD47', '#E95513'],
    legendData: ['English', 'Mandarin', 'Spanish', 'Italian', 'Vietnamese', 'Others'],
    seriesData: [{value: 31, name: 'English'}, {value: 29, name: 'Mandarin'}, {value: 15, name: 'Spanish'}, {
      value: 13, name: 'Italian'
    }, {value: 7, name: 'Vietnamese'}, {value: 5, name: 'Others'}]
  };
  customerType = {
    title: 'Customer Type',
    colors: ['#FF0D90', '#05CD99', '#8676FF',],
    legendData: ['New Customer', 'Purchased Customer', 'Multiple Visit Customer'],
    seriesData: [{value: 30, name: 'New Customer'}, {value: 23, name: 'Purchased Customer'}, {
      value: 47, name: 'Multiple Visit Customer'
    }]
  };
  referralsChanel = {
    title: 'Referral Channels',
    colors: ['#FF0D90', '#8676FF', '#A7E7F2', '#05CD99', '#FFAD47', '#E95513', '#454F85'],
    legendData: ['Television ads', 'Social Media', 'Digital ads', 'Website', 'YepHome', 'Agency', 'Others'],
    seriesData: [{value: 24, name: 'Agency'}, {value: 13, name: 'Phone calls'}, {value: 12, name: 'Digital ads'}, {
      value: 5, name: 'Television ads'
    }, {value: 4, name: 'Website'}, {value: 4, name: 'YepHome'}, {value: 6, name: 'Others'}]
  };

  demography: any;
  rentRatio: any;
  owner: any;
  rented: any;

  employed: any;
  unemployed: any;
  employRatio: any;

  constructor(private route: ActivatedRoute, public sanitizer: DomSanitizer, private httpService: HttpService, private userService: UserService) {
  }

  ngOnInit(): void {
    console.log('---project details---', this.project);
    this.currentUserId = this.userService.getCurrentUser().idOrigin;

    if (this.project) {
      this.projectId = this.project.id;
      this.getAnalysisData()
    } else {
      console.log(this.currentUserId);
      this.projectId = this.route.snapshot.paramMap.get('id');
      console.log(this.projectId);
      this.httpService.getProjectDetailByProjectId(this.projectId).subscribe((res: any) => {
        console.log(res);
        this.project = res.data;
        this.getAnalysisData()
      });
    }
  }

  getAnalysisData() {
    this.project.availableNum = this.project.properties.filter(i => i.status === 1).length;
    this.project.reserveNum = this.project.properties.filter(i => i.status === 3).length;
    this.project.soldNum = this.project.properties.filter(i => i.status >= 3).length;
    this.httpService.getSuburbPopulation(this.project.postCode).subscribe((r: any) => {
      console.log(r);
      if (r.code === 1) {
        const suburb = this.project.area;
        console.log(suburb);
        if (r.data.doc) {
          this.demography = r.data.doc.filter(item => this.trim(item.suburb_name.toLowerCase()) === suburb.toLowerCase())[0];
        }
        if (this.demography) {
          if (this.demography.rent_rate) {
            const owner = this.demography.rent_rate['Owned outright'].number + this.demography.rent_rate['Owned with a mortgage'].number;
            const rented = this.demography.rent_rate.Rented.number;
            this.owner = owner;
            this.rented = rented;
            if (owner >= rented) {
              this.rentRatio = (owner / rented).toFixed(1);
            } else {
              this.rentRatio = (rented / owner).toFixed(1);
            }
            console.log(this.owner, this.rented);
          }
          if (this.demography.employment) {
            const employed = this.demography.employment['Worked full-time'].number + this.demography.employment['Worked part-time'].number + this.demography.employment['Away from work'].number;
            const unemployed = this.demography.employment['Unemployed'].number;
            this.employed = employed;
            this.unemployed = unemployed;
            if (employed >= unemployed) {
              this.employRatio = (employed / unemployed).toFixed(1);
            } else {
              this.employRatio = (unemployed / employed).toFixed(1);
            }
          }
          if (this.demography.age_in_group) {
            this.demography.age_group_sorted = Object.entries(this.demography.age_in_group).sort((a: any, b: any) => b[1].percentage - a[1].percentage);
            // Render age chart
            // for (let i = 0; i < 5; i++) {
            //   this.ageChartOption.xAxis.data.push(this.formatAgeGroupName(this.demography.age_group_sorted[i][0]));
            //   this.ageChartOption.series[0].data[i].value = Number((this.demography.age_group_sorted[i][1].percentage * 100).toFixed(2));
            // }
            // if (this.ageChartInstance) {
            //   this.ageChartInstance.setOption(this.ageChartOption);
            // }
          }
          if (this.demography.occupation) {
            this.demography.occupation_sorted = Object.entries(this.demography.occupation).sort((a: any, b: any) => b[1].percentage - a[1].percentage);
            // Render occupation chart
            // for (let m = 0; m < 5; m++) {
            //   this.occupationChartOption.xAxis.data.push(this.formatCapitalLetter(this.demography.occupation_sorted[m][0]));
            //   this.occupationChartOption.series[0].data[m].value = Number((this.demography.occupation_sorted[m][1].percentage * 100).toFixed(2));
            // }
            // if (this.occupationChartInstance) {
            //   this.occupationChartInstance.setOption(this.occupationChartOption);
            // }
          }
        }
        console.log(this.demography);
        this.project.demography = this.demography;
      }

    });
  }

  // 去掉前后空格
  trim(str) {
    // console.log(str.replace(/(^\s*)|(\s*$)/g, ''));
    return str.replace(/(^\s*)|(\s*$)/g, '');
  }

}
